export const SERVING_STATUS = {
  pending: {
    label: 'pending',
    value: 'pending',
    color: 'baseColor.color4',
    dashColor: 'baseColor.color4',
  },
  confirmed: {
    label: 'served',
    value: 'confirmed',
    color: 'baseColor.color2',
    dashColor: 'baseColor.color2',
  },
  cancelled: {
    label: 'cancelled',
    value: 'cancelled',
    color: 'baseColor.color6',
    dashColor: 'baseColor.color6',
  },
}

export const SERVING_STATUS_COLOR = {
  pending: 'color4',
  confirmed: 'color2',
  finish_cooking: 'color19',
  cancelled: 'color6',
}

export const SERVING_REQUEST_STATUS = {
  food_order: 'food_order',
  call_staff: 'call_staff',
}
